import { Col, Row } from 'antd';
import React from 'react';
import { withRouter } from 'react-router-dom';

import AppContext from '../services/Context';
import styled from '../styled-components';
import FormBuilder, { FormSettingsType } from './Form';

const PageBG = require('../images/login-bg.png');
const LoginBG = require('../images/login.png');
const GoEpikLogoImg = require('../images/goepik-vertical-logo.png');


export default withRouter(
  ({ children, location }: { children?: React.ReactNode; location: { pathname: string } }) => (
    <AppContext.Consumer>
      {({ theme, authorized, ChangeLocale, client, locale }) => {
        const ChangeLocaleForm: FormSettingsType = {
          submitOnFieldChange: true,
          fields: [
            {
              type: 'select',
              name: 'locale',
              optionLabel: 'label',
              optionValue: 'value',
              items: [
                { value: 'en', label: 'English' },
                // { value: 'es', label: 'Espanõl' },
                { value: 'pt-BR', label: 'Português' }
              ],
              hideClearButton: true,
              initialValue: locale,
              addorn: {
                leftIcon: 'globe',
              },
            },
          ],
        };
        return (
          <Wrapper>
            <Row type="flex" justify="space-between" align="middle">
              <Col xs={0} sm={12} md={13} xl={15} xxl={16}>
                <Left>
                  <LogoContainer className="customer">
                    <Logo src={LoginBG} alt="" />
                  </LogoContainer>
                </Left>
              </Col>
              <Col xs={24} sm={12} md={11} xl={9} xxl={8} >
                <Right className={`height-100`}>
                  <Header>
                    <LogoContainer className="goepik">
                      <LogoHeader src={client.logo || GoEpikLogoImg} alt="" />
                    </LogoContainer>
                    <LocaleSwitch>
                      <FormBuilder
                        settings={ChangeLocaleForm}
                        onSubmit={(values: { locale: string }) =>
                          values.locale ? ChangeLocale(values.locale) : null
                        }
                      />
                    </LocaleSwitch>
                  </Header>
                  {children}
                </Right>
              </Col>
            </Row>
          </Wrapper>
        )
      }}
    </AppContext.Consumer>
  ),
);

const Wrapper = styled.div`
    height: 100vh;
    min-height: 100%;
    width: 100%;
    background-color: #335D7C;
`;

const Left = styled.div`

  &.withBg {
    background: url(${PageBG}) no-repeat;
    background-size: cover;
  }
`;

const Right = styled.div`
  background: #FFFFFF;
  padding: 20px 4.479vw 0px 4.479vw;
  min-height: 100vh;
  
`;

const Header = styled.div`
  flex: 1;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  .form-select-wrapper {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const LogoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0 20px 0 50px;
 
  &.customer {
    img {
        /* max-width: 400px; */
    }
  }
  &.goepik {
    flex: 0 0 80px;
    margin: 0;
  }
`;

const LocaleSwitch = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0 20px 0 50px;
  width: auto;
`;

const Logo = styled.img`
  max-width: 70vw;
  max-height: 100%;
`;

const LogoHeader = styled.img`
@media only screen and (max-width: 500px){
  max-width: 35vw;
}
  max-width: 12vw;
  max-height: 100%;
  padding-top: 12%;
`;